import {Digits, MIN_MILLIONT_VALUE, MIN_ROUND_OFF_VALUE} from '../constants';

import type {Digit} from '../constants';

/**
 * @description Convert value to specified digit
 * @param {number} value - Input value
 * @param {Digit=} toDigit - Output digit
 * @return {Digit} converted digit
 */
export const getCurrentDigit = (
    value: number,
    toDigit: Digit = Digits.ONE,
): Digit => {
    const moduloValue = Math.abs(value);

    if (moduloValue < MIN_ROUND_OFF_VALUE) {
        return Digits.ONE;
    }

    return moduloValue >= MIN_ROUND_OFF_VALUE &&
        moduloValue < MIN_MILLIONT_VALUE
        ? Digits.THOUSAND
        : toDigit;
};
